import React from 'react'
import styled from "styled-components"

const SectionWrapper = styled.section`
      background-color: #FFF;
      max-width: 980px;
      min-height: 100vh;
      box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.04);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin: 0 auto;
`

const StepsContainer = ({children}) => {
    return (
        <SectionWrapper>
            {children}
        </SectionWrapper>
    )
}

export default StepsContainer
